import React from 'react';
var redirectURL = require('../redirectURL');

const Vendorparticipationscomponent = (props) => {
  const handleClick = (type, e) => {
    e.stopPropagation();

    const context = props.context.componentParent;

    switch (type) {
      case 'material':
        context.onClickshowbiddata(props);
        break;
      case 'attachment':
        context.onClickViewPOD(props);
        break;
      case 'comment':
        context.onClickComments(props);
        break;
      case 'bidding':
        context.onClickviewRFQ(props);
        break;
      case 'notification':
        context.fetchNotificationsData(props);
        break;
      default:
        break;
    }
  };

  const unreadCount = props.data && props.data.indent.notification_count;
  return (
<div className="flex-gap-relative">
      {/* Bid */}
      <button
   onClick={(e) => {
    if (
      props.data.indent &&
      Array.isArray(props.data.indent.vendorquotes) &&
      props.data.indent.vendorquotes.length > 0
    ) {
      handleClick('material', e);
    }
  }}
  className="custom-btn label label-success"
  title="Bid Details"
>
  {props.data.indent &&
  Array.isArray(props.data.indent.vendorquotes) &&
  props.data.indent.vendorquotes.length > 0 ? (
    <img src={require('../../assets/images/Group 976.png')} alt="Bid Details" />
  ) : (
    <img src={require('../../assets/images/biddetailsdisable.png')} alt="Bid Details" />

  )}
</button>

    </div>
  );
};

export default Vendorparticipationscomponent;
